import React from 'react';
import useResponsive from '../hooks/useResponsive';
import useCountdown from '../hooks/useCountdown';
import Countdown from '../shared/Countdown';
import ActionButton from '../shared/ActionButton';
import styles from '../styles/MigrationBanner.module.css';

/**
 * Banner de Migración - Muestra imagen completa con countdown y botón
 * @param {Object} images - { desktop, mobile }
 * @param {Object} countdown - { enabled, targetDate }
 * @param {Object} action - { label, handler, subtitle, icon }
 */
const MigrationBanner = ({ images, countdown: countdownConfig, action }) => {
  const { isMobile } = useResponsive();
  const countdown = useCountdown(countdownConfig?.enabled ? countdownConfig.targetDate : null);

  const handleAction = () => {
    if (typeof action.handler === 'string') {
      window.open(action.handler, '_blank');
    } else if (typeof action.handler === 'function') {
      action.handler();
    }
  };

  return (
    <div className={styles.migrationBanner}>
      {/* Columna de imagen */}
      <div className={styles.imageColumn}>
        <img 
          src={isMobile ? images.mobile : images.desktop}
          alt="Nueva aplicación móvil"
          className={styles.bannerImage}
        />
      </div>

      {/* Columna de contenido */}
      <div className={styles.contentColumn}>
        {countdownConfig?.enabled && (
          <div className={styles.countdownWrapper}>
            <Countdown 
              countdown={countdown} 
              label="FALTAN"
            />
          </div>
        )}
        
        {action && (
          <div className={styles.actionWrapper}>
            <ActionButton
              onClick={handleAction}
              icon={action.icon}
              subtitle={action.subtitle}
              variant="primary"
            >
              {action.label}
            </ActionButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default MigrationBanner;
